import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import moment from "moment";
import { AppIcons } from "../constants/app-icons";
import { Core } from "../helpers/core";
import { Money } from "../helpers/money";
import { DOMAIN } from "./domain-constant";

export default class FundReceivedService extends ApiService {
  namespace = "fund-received";
  listingRelations = "customer,paymentMethod";
  relations = "?expand=invoices,overPayments,credits,writeoffs,journals,invoices.invoice,customer,files,files.file";
  template = "defaultTemplate";
  fullWindow = false;
  icon = "CircleWithDollarSign2";
  DOMAIN = DOMAIN.FUND_RECEIVED;
  data = [];
  favicon = "Invoice";
  name = "Payment";
  singular = this.terminology.fundReceived.singular;
  plural = this.terminology.fundReceived.plural;
  vowel = this.terminology.fundReceived.vowel;
  layout = 2;
  showLeftBar = false;
  useNextNumber = true;
  Width = 1300;
  gemItems = [
    {
      key: "listing",
      label: "All Funds Recieved",
      icon: AppIcons.BULLETS,
    },
    {
      key: "create",
      label: "Add Customer Payment",
      icon: AppIcons.PLUS,
    },
    {
      key: "create",
      label: "Add Other Funds Recieved",
      services: DOMAIN.OTHER_FUNDS,
      icon: AppIcons.PLUS,
    },
  ];
  columns = [
    {
      header: this.t("number"),
      icon: AppIcons.SHRED,
      field: "number",
      sortable: true,
    },
    {
      header: this.t("Entity"),
      icon: AppIcons.USER_SILHOUETTE,
      field: "customer",
      template: (data) => data.customer?.display_name ?? "",
    },
    {
      header: this.t("methods"),
      icon: AppIcons.CREDIT_CARD_GREEN,
      field: "method",
      sortable: true,
      template: (data) => data.paymentMethod?.display_name ?? "",
    },
    {
      header: this.t("date"),
      icon: AppIcons.GREEN_CALENDAR,
      field: "date",
      sortable: true,
      template: (data) => Core.datey(data.date),
    },

    {
      header: this.t("amount"),
      icon: AppIcons.MONEY,
      field: "amount",
      sortable: true,
      template: (data) => Money.format(data.amount),
    },

    {
      header: "",
      icon: AppIcons.BLUE_CIRCLE_WITH_DOLLAR_SIGN,
      field: "status",
      tooltip: "Payment Type",
      template: (data) => {
        return data.type_code ?? "";
      },
    },
    {
      header: "",
      icon: AppIcons.BUILDING,
      field: "is_deposited",
      tooltip: "Payment Deposited",
      template: (data) => {
        return data.is_deposited === true ? "Yes" : "";
      },
    },
  ];

  moreItems = [
    {
      key: "create",
      label: "Load template",
      icon: AppIcons.FOLDER,
      type: "1",
    },
    {
      key: "create",
      label: "Save and preview",
      icon: AppIcons.PREVIEW,
      type: "2",
    },
    {
      key: "create",
      label: "Save and print",
      icon: AppIcons.PRINTER,
      type: "3",
    },
    {
      key: "create",
      label: "Save and e-mail",
      icon: AppIcons.MAIL,
      type: "4",
    },
    {
      key: "create",
      label: "Manage layout",
      icon: AppIcons.LAYOUT,
      type: "5",
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "draft",
      label: this.t("viewEntity", { entity: this.t("drafts") }),
      icon: AppIcons.DOCUMENT_WITH_TEXT,
    },
    {
      key: "customer",
      label: this.t("viewEntity", { entity: this.t("customerPayments") }),
      icon: AppIcons.DOCUMENT_WITH_TEXT,
    },
    {
      key: "other",
      label: this.t("viewEntity", { entity: this.t("otherFundsReceived") }),
      icon: AppIcons.DOCUMENT_WITH_TEXT,
    },
    {
      key: "undeposited",
      label: this.t("viewEntity", { entity: this.t("undepositedFunds") }),
      icon: AppIcons.MONEY,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: this.t("editThisEntity", { entity: this.singular }),
      icon: AppIcons.EDIT,
    },
    {
      key: "transaction",
      label: this.t("transactionSummary"),
      icon: AppIcons.MONEY,
    },
    {
      key: "bookmark",
      label: this.t("bookmarkThisEntity", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "viewJournal",
      label: this.t("viewJournal"),
      icon: AppIcons.JOURNAL_VIEW,
    },
  ];
  getActionMenu(item) {
    return this.listMenuItems;
  }
  permissions = [
    {
      key: "is_in_print_que",
      display_name: "Print Que",
      icon: AppIcons.FAX,
      value: 1,
    },
  ];
  filterItems = [
    { name: "Status", key: "status", value: "2", realm: "2" },
    { name: "Date", key: "date", value: "3", realm: "1" },
    { name: "Due Date", key: "due", value: "4", realm: "0" },
  ];
  
  gemMenuItems = [
    {
      key: "create",
      label: "Add Customer Payment",
      icon: AppIcons.LIST,
    },
  ];

  constructor() {
    super("payments");
  }
}
